import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Switch } from "@/components/ui/switch";
import { useI18n } from "@/context/Shop";

const KEY = "lc_cookie_prefs";
export const readCookiePrefs = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; }
};
export const saveCookiePrefs = (prefs) => {
  const v = { necessary: true, analytics: !!prefs.analytics, personalization: !!prefs.personalization, recorded_at: new Date().toISOString() };
  try { localStorage.setItem(KEY, JSON.stringify(v)); } catch { /* ignore */ }
  window.dispatchEvent(new Event("lc-cookie-prefs"));
  return v;
};

const COPY = {
  en: { necessary: "Strictly necessary", necessary_sub: "Sign-in sessions, security and your saved bag. Always on.", analytics: "Analytics", analytics_sub: "Helps us understand how the store is used. No analytics provider is configured yet, so nothing is sent.", personal: "Personalisation", personal_sub: "Remembers recently viewed products on this device.", save: "Save preferences" },
  sq: { necessary: "Rreptësisht të nevojshme", necessary_sub: "Sesionet e hyrjes, siguria dhe shporta jote e ruajtur. Gjithmonë aktive.", analytics: "Analitikë", analytics_sub: "Na ndihmon të kuptojmë si përdoret dyqani. Asnjë ofrues analitike nuk është konfiguruar ende, kështu që asgjë nuk dërgohet.", personal: "Personalizim", personal_sub: "Mban mend produktet e para së fundmi në këtë pajisje.", save: "Ruaj preferencat" },
};

export function CookiePreferencesForm({ onSaved }) {
  const { lang } = useI18n();
  const c = COPY[lang] || COPY.en;
  const cur = readCookiePrefs() || { analytics: false, personalization: false };
  const [a, setA] = useState(!!cur.analytics);
  const [p, setP] = useState(!!cur.personalization);
  return (
    <div className="space-y-5" data-testid="cookie-preferences-form">
      <div className="flex items-start justify-between gap-6"><div><p className="text-sm font-semibold">{c.necessary}</p><p className="text-xs text-muted-foreground mt-1">{c.necessary_sub}</p></div><Switch checked disabled aria-label={c.necessary} /></div>
      <div className="flex items-start justify-between gap-6"><div><p className="text-sm font-semibold">{c.analytics}</p><p className="text-xs text-muted-foreground mt-1">{c.analytics_sub}</p></div><Switch checked={a} onCheckedChange={setA} aria-label={c.analytics} data-testid="cookie-analytics-switch" /></div>
      <div className="flex items-start justify-between gap-6"><div><p className="text-sm font-semibold">{c.personal}</p><p className="text-xs text-muted-foreground mt-1">{c.personal_sub}</p></div><Switch checked={p} onCheckedChange={setP} aria-label={c.personal} data-testid="cookie-personalization-switch" /></div>
      <button className="btn-ink" onClick={() => { saveCookiePrefs({ analytics: a, personalization: p }); onSaved && onSaved(); }} data-testid="cookie-save-button">{c.save}</button>
    </div>
  );
}

export function CookieBanner() {
  const { t } = useI18n();
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(!readCookiePrefs());
  }, []);
  if (!show) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-md z-[60] bg-background border shadow-[0_18px_50px_hsl(var(--shadow-2))] p-6" role="dialog" aria-label={t("cookie_title")} data-testid="cookie-banner">
      <p className="font-display text-xl">{t("cookie_title")}</p>
      <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{t("cookie_text")} <Link to="/customer-care/cookies" className="link-lux text-foreground" onClick={() => setShow(false)}>{t("manage_prefs")}</Link></p>
      <div className="flex gap-3 mt-5">
        <button className="btn-ink h-10 px-5 flex-1" onClick={() => { saveCookiePrefs({ analytics: true, personalization: true }); setShow(false); }} data-testid="cookie-accept-all-button">{t("accept_all")}</button>
        <button className="btn-ghost-lux h-10 px-5 flex-1" onClick={() => { saveCookiePrefs({ analytics: false, personalization: false }); setShow(false); }} data-testid="cookie-necessary-only-button">{t("necessary_only")}</button>
      </div>
    </div>
  );
}
